<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务成果确认</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="tips-area text-center">
                <div class="tips-area__icon">
                    <i class="el-icon-check"></i>
                </div>
                <div class="tips-area__msg">
                    提交成功
                </div>
                <div class="tips-area__desc">
                    请联系财务或管理员对提交的服务成果进行支付
                </div>
                <div class="tips-area__footer">
                    <el-button @click="goPage(`/index/project`)" size="small" type="default">返回</el-button>
                    <el-button v-if="$route.query.sub_id!=='batch'" @click="goPage(`/index/project/serviceinfo?id=${$route.query.id}&sub_id=${$route.query.sub_id}`)" size="small" type="primary">查看</el-button>
                    <el-button v-else @click="goPage(`/index/project/detail?id=${$route.query.id}&panel=1`)" size="small" type="primary">查看</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step3',
    inject: ['back', 'goPage', 'tel']
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub";
    .tips-area {
        margin-top: 114px;
        .tips-area__icon {
            display: inline-block;
            border-radius: 50%;
            color: #fff;
            line-height: 108px;
            font-size: 48px;
            width: 100px;
            height: 100px;
            background-color: $--color-primary;
        }
        .tips-area__msg {
            margin-top: 28px;
            font-size: 18px;
            font-weight: 700;
        }
        .tips-area__desc {
            margin-top: 10px;
        }
        .tips-area__footer {
            margin-top: 56px;
            button {
                width: 100px;
            }
        }
    }
</style>
